export default {
  initial: {},
  changed: {},
  data: {},
};
